export const WorkoutPlayerTimer = {
  bindings: {
    step: '<',
    elapsedTime: '<',
    countdown: '<',
    onStarted: '&',
    onCompleted: '&',
  },

  template: `
    <div class="current-exercise-panel-inner">
      <div class="attribute"
        ng-repeat="attribute in $ctrl.step.displayAttributes track by $index">
        <div class="timer-container" ng-if="$index === 0">
          <strong class="timer-title">
            {{ attribute }}
          </strong>
          <span class="sets-count text-uppercase"
            ng-if="$ctrl.step.setsCount > 0">
            <span class="pipe-divider">|</span>
            Set
            {{ $ctrl.step.setNumber }}
            of
            {{ $ctrl.step.setsCount }}
          </span>
          <div class="exercise-progress animated-progress-bar-container"></div>
          <span class="timer-value">
            <span ng-if="attribute === 'time'">
              {{ $ctrl.time | date: 'm:ss' }}
            </span>
            <span ng-if="attribute !== 'time'">
              {{ $ctrl.step[attribute] || $ctrl[attribute] }}
            </span>
          </span>
          <div class="amrap" ng-if="$ctrl.step.amrap">
            AMRAP
          </div>
        </div>
        <div class="meta-container" ng-if="$index > 0">
          <span class="meta-name" ng-switch="attribute">
            <span ng-switch-when="eachSide">
              Side
            </span>
            <span ng-switch-when="inclineNumber">
              Incline
            </span>
            <span ng-switch-default>
              {{ attribute }}
            </span>
          </span>
          <span class="meta-value" ng-switch="attribute">
            <span ng-switch-when="eachSide">
              {{ $ctrl.side }}
            </span>
            <span ng-switch-when="alternate">
              {{ $ctrl.side }}
            </span>
            <span ng-switch-default>
              {{ $ctrl.step[attribute] }}
            </span>
          </span>
        </div>
      </div>
      <div class="meta-container amrap" ng-if="$ctrl.step.amrap">
        AMRAP
      </div>
    </div>`,

  controller() {
    'ngInject';

    return {
      $onInit() {
        this.started = false;
        this.completed = false;
      },

      $onChanges(changesObj) {
        if (this.step && (changesObj.elapsedTime || changesObj.countdown)) {
          this.update();
        }
      },

      update() {
        const { step, elapsedTime, countdown } = this;

        // Callbacks for started/completed
        const started = countdown === 0;
        const completed = elapsedTime === step.totalTimeInSeconds;

        if (started && !this.started) {
          this.onStarted();
        }

        if (completed && !this.completed) {
          this.onCompleted();
        }

        this.started = started;
        this.completed = completed;

        this.setSide();
        this.setReps();
        this.setTime();
      },

      setSide() {
        const { completed, elapsedTime, started, step } = this;

        // Side
        let side = '';

        // Alternate exercise
        if (
          step.alternate &&
          ((Math.floor(elapsedTime / step.repTime) + 1) % 2 > 0 ||
            elapsedTime === 0) &&
          !completed
        ) {
          side = 'Left';
        } else if (
          (step.alternate &&
            (Math.floor(elapsedTime / step.repTime) + 1) % 2 === 0) ||
          completed
        ) {
          side = 'Right';
        } else if (step.eachSide && elapsedTime < step.totalTimeInSeconds / 2) {
          side = 'Left';
        } else if (
          step.eachSide &&
          elapsedTime >= step.totalTimeInSeconds / 2
        ) {
          side = 'Right';
        }

        // Don't show specific side if we haven't started
        if (!started) {
          if (step.alternate) {
            side = 'L/R';
          } else if (step.eachSide) {
            side = 'Each';
          }
        }

        this.side = side;
      },

      setReps() {
        const { elapsedTime, side, started, step } = this;

        // Reps complete
        let reps = Math.floor(elapsedTime / step.repTime) + 1;

        if (step.eachSide && side === 'Right') {
          // Adjusting reps for the second half of side based exercise
          reps -= step.repsCount;
        }

        reps = started
          ? Math.min(reps, step.repsCount) + '/' + step.repsCount
          : step.repsCount;

        this.sameRep = this.reps === reps;
        this.reps = reps;
      },

      // Time remaining
      setTime() {
        const { elapsedTime, side, step } = this;

        let time = step.totalTimeInSeconds - elapsedTime;

        // Halve time for side based exercises
        if (step.eachSide && side === 'Left') {
          time -= step.totalTimeInSeconds / 2;
        }

        time = Math.max(time, 0);

        this.time = time * 1000;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerTimer.js